import RouteParent from 'js/router/route-parent'
import LeadsIndex from 'js/pages/accounts/index.js'

export default [
  {
    path: '/leads',
    component: RouteParent,
    meta: {
      auth: true,
      menuParent: 'Registro de Actividad',
      menuLabel: 'Leads',
      menuIcon: 'user'
    },
    children: [
      {
        path: '',
        name: 'leads-index',
        component: LeadsIndex,
        meta: {
          auth: true,
          title: 'Leads'
        }
      }
    ]
  }
]
